<template>
  <div class="changeInfo mjbg_page">
    <div style="background:#fff;padding: 15px">
      <el-form ref="form" label-position="top" :model="form" :rules="rules" label-suffix="：">
        <el-card class="mjArea" v-for="(item,ind) in mjArea" :key="ind" >
          <el-form-item  label="原供热面积（m²）">
            <el-input placeholder="供热面积" disabled v-model.trim="item.sfmj"></el-input>
          </el-form-item>
          <el-form-item label="新供热面积（m²）" >
            <el-input-number :controls="false" style="width: 100%;text-align:left" :min="0" placeholder="供热面积" v-model.trim.number="item.sfmj1"></el-input-number>
          </el-form-item>
        </el-card>
        <el-form-item label="手机号" prop="mobNo">
          <el-input placeholder="手机号"  v-model.trim="form.mobNo"></el-input>
        </el-form-item>
        <el-form-item prop="captcha" v-if="captchaValidate">
          <el-input v-model.trim="form.captcha" type="text" style="width: 60%" placeholder="验证码"></el-input>
          <button :disabled="disabled" @click="getYzm" type="button" class="yzmBtn" style="width: 38%;">{{msg}}</button>
        </el-form-item>
        <el-form-item label="上传附件">
          <div class="file" v-if="imageId">
            <input
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getId"
            />身份证正面
          </div>
          <div v-for="(item,ind) in imgIdList" :key="ind" class="imgDiv">
            <b @click="deleteImgId(ind)" class="el-icon-error error_icon"></b>
            <img class="imgItemRead avatar"   :src="item" alt="">
          </div>
          <div class="file" v-if="imageIdBack">
            <input
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getIdBack"
            />身份证背面
          </div>
          <div v-for="(item,ind) in imgIdBackList" :key="ind" class="imgDiv">
            <b @click="deleteImgIdBack(ind)" class="el-icon-error error_icon"></b>
            <img class="imgItemRead avatar"   :src="item" alt="">
          </div>
          <li>
            <span class="redText" style="font-size: 10px">注意：仅需上传户主信息、房屋信息及签章页</span>
          </li>
          <div class="file">
            <input
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getFile"
            />房产证或购房合同
          </div>
          <div v-for="(item,ind) in imgList" :key="ind" class="imgDiv">
            <b @click="deleteImg(ind)" class="el-icon-error error_icon"></b>
            <img class="imgItemRead avatar"   :src="item" alt="">
          </div>
        </el-form-item>
      </el-form>
      <button @click="changeInfoa" class="btn_bind" style="width: 100%">确认修改</button>
    </div>
  </div>
</template>
<script>
  import { verifyToken, getCaptcha, findArea, saveMjbg} from "@/api";
  export default {
    data() {
      return {
        fileList: [],
        form: {},
        imgList: [],
        imgIdList: [],
        imgIdBackList: [],
        imageId:true,
        imageIdBack:true,
        imagefcz:true,
        ceshi:'',
        imgHref:'',
        accessToken:'',
        msg: '获取验证码',
        disabled: false,
        rules: {
          name: [
            {
              required: true, message: '必填',trigger:'blur'
            }
          ],
          idNumber: [
            {
              required: true, message: '必填',trigger:'blur'
            },
            {
              required: true, max: 18,min:18,message: '请输入18位有效身份证号',trigger:'blur'
            }
          ],
          mobNo: [
            {
              required: true, message: '必填',trigger:'blur'
            },
            {
              required: true, max: 11,min:11,message: '请输入11位有效手机号',trigger:'blur'
            }
          ],
        },
        mjArea: [],
        captchaValidate: true
      };
    },
    mounted() {
      this.getAreaList()
      this.captchaValidate = JSON.parse(sessionStorage.getItem('roles'))&&JSON.parse(sessionStorage.getItem('roles')).captchaValidate

    },
    methods: {
      validator:(rule, value, callback) => {
        console.log(rule,callback)
        if (value !== '') {
          if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
            callback(new Error('请填写大于0的数字'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      getAreaList() {
        findArea({
          customerId: this.$route.query.userId,
        }).then((res) => {
          this.mjArea = res.data;
        });
      },
      changeInfoa() {
        //创建formdata对象
        this.$refs.form.validate((valid) => {
          if (valid) {
            let areaListJson = []
            this.mjArea.map(v=>{
              if(v.sfmj1>=0) {
                areaListJson.push({
                  id: v.id,
                  sfmj: v.sfmj1
                })
              }
            })
            if(!areaListJson.length){
              this.$toast('请输入需要更改的面积')
              return
            }
            if(this.captchaValidate&&!this.form.captcha) {
              this.$toast('请输入验证码')
              return;
            }
            if(!this.imgIdList.length) {
              this.$toast('请上传身份证正面')
              return;
            }
            if(!this.imgIdBackList.length) {
              this.$toast('请上传身份证背面')
              return;
            }
            if(!this.imgList.length) {
              this.$toast('请上传房产证或购房合同')
              return;
            }
            this.form.customerId = this.$route.query.userId
            this.form.areaListJson = JSON.stringify(areaListJson)
            var formdata = new FormData();
            for (let k in this.form) {
              formdata.append(k, this.form[k]);
            }
            this.fileList.map(file=>{
              formdata.append("files", file);
            })

            saveMjbg(formdata).then(res=>{
              if(res) {
                this.$toast('提交成功')
                this.$router.go(-1)
              }
            });
          }
        })


      },
      getFile(e) {
        let file = e.target.files[0]
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload =  (e) => {    //成功读取文件
          this.imgList.push(e.target.result)
        };
        this.imagefcz = false
      },
      getId(e){
        let file = e.target.files[0]
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload =  (e) => {    //成功读取文件
          this.imgIdList.push(e.target.result)
        };
        this.imageId = false
      },
      getIdBack(e){
        let file = e.target.files[0]
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload =  (e) => {    //成功读取文件
          this.imgIdBackList.push(e.target.result)
        };
        this.imageIdBack = false
      },
      deleteImg(ind) {
        this.imgList.splice(ind,1);
        this.fileList.splice(ind,1)
        this.imagefcz = true
      },
      deleteImgId(ind) {
        this.imgIdList.splice(ind,1);
        this.fileList.splice(ind,1)
        this.imageId = true
      },
      deleteImgIdBack(ind) {
        this.imgIdBackList.splice(ind,1);
        this.fileList.splice(ind,1)
        this.imageIdBack = true
      },
      getBaiduToken(){
        verifyToken().then(res => {
          this.accessToken = res.data
          console.log(this.accessToken)
        })
      },
      imghref(){
        this.imgHref = 'https://brain.baidu.com/face/print/'+"?token="+this.accessToken+"&successUrl="+window.location.href+this.$route.path+"?code="+this.$route.query.code+"?userId="+this.$route.query.userId+sessionStorage.setItem('companyCode',sessionStorage.getItem("companyCode"))+"&failedUrl="+window.document.location.href+"?code="+this.$route.query.code+"?userId="+this.$route.query.userId
      },
      getYzm() {
        var reg_tel = /^(1)\d{10}$/;
        if(!reg_tel.test(this.form.mobNo)) {
          this.$toast('请输入正确的手机号码')
          return
        }
        let params = {
          sysType: 0,
          phone: this.form.mobNo,
        }
        getCaptcha(params).then(res=>{
          if(res.code=='0000') {
            this.maxtime = 60
            this.disabled = true
            this.timer = setInterval(() => {
              this.CountDown()
            }, 1000)
          }
        })
      },
      CountDown() {
        if (this.maxtime > 0) {
          let seconds = this.maxtime
          this.msg =   + seconds + "s"+'后获取';
          --this.maxtime;
        } else{
          clearInterval(this.timer);
          this.msg = '获取验证码'
          this.disabled = false
        }
      }

    },
  };
</script>
<style>
  .changeInfo {
    padding: 3%;
    min-height: 90%;
  }
  .redText {
    color: red;
  }
  .uploader-file {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .yzmBtn{
    border: 1px solid #C2E7B0;
    border-radius: 3px;
    line-height: 26px;
    background: #F0F9EB;
    color: #67C23A;
    font-size: 12px;
    /*background: #000;*/
  }
  .uploader-file:hover {
    border-color: #409eff;
  }
  .mjArea{
    margin-top: 5px;
    /*border-bottom: 1px solid #ccc;*/
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 100%;
    height: 178px;
    display: block;
    margin-top: 25px;
  }

  .file {
    width: 92%;
    height: 30px;
    position: relative;
    display: inline-block;
    background: #FBFDFF;
    border: 1px  #C0CCDA dashed;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    text-align: center;
    line-height: 30px;
  }
  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }
  .file:hover {
    background: #FBFDFF;
    border-color: #AADFFD;
    color: #004974;
    text-decoration: none;
  }
  .imgDiv{
    position: relative;
  }
  .error_icon{
    position: absolute;
    font-size: 25px;
    right: -15px;
    top:-18px;
    z-index: 999999;
    color: #f00;
  }
 .mjbg_page .el-input-number.is-without-controls .el-input__inner{
   text-align: left!important;
}
</style>



// WEBPACK FOOTER //
// src/view/ywbl/mjbg/index.vue